import type { CSSProperties } from 'react';
import { iconDefinitions, type IconName } from '@deepdive-icons';
import styles from './Icon.module.css';

export type IconProps = {
  name: IconName;
  /**
   * Accessible name. Omit for decorative icons (the default) — they are then
   * hidden from assistive tech, which is correct when an adjacent label already
   * names the thing.
   */
  label?: string;
  className?: string;
  style?: CSSProperties;
};

/**
 * A 12x12 icon from the Figma icon set.
 *
 * Colour comes from `currentColor`, so callers set it with an icon/* token
 * rather than passing a colour prop.
 */
export function Icon({ name, label, className, style }: IconProps) {
  const definition = iconDefinitions[name];
  const decorative = label === undefined;

  return (
    <svg
      className={className ? `${styles.icon} ${className}` : styles.icon}
      style={style}
      viewBox={definition.viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role={decorative ? undefined : 'img'}
      aria-label={label}
      aria-hidden={decorative || undefined}
      focusable="false"
    >
      {definition.paths.map((d) => (
        <path key={d.slice(0, 32)} d={d} fill="currentColor" />
      ))}
    </svg>
  );
}
